export type LinkTargetMode = 'none' | 'page' | 'url';

export interface LinkTargetValue {
    customPageId?: number;
    url?: string;
}

export function getLinkTargetMode(value: LinkTargetValue): LinkTargetMode {
    if (value.customPageId) return 'page';
    if (value.url) return 'url';
    return 'none';
}

// A API aceita página customizada OU URL, nunca ambos: ao trocar o modo o destino oposto é descartado
export function changeLinkTargetMode(value: LinkTargetValue, mode: LinkTargetMode): LinkTargetValue {
    if (mode === 'page') return { customPageId: value.customPageId, url: undefined };
    if (mode === 'url') return { customPageId: undefined, url: value.url };
    return { customPageId: undefined, url: undefined };
}

export function validateLinkTarget(mode: LinkTargetMode, value: LinkTargetValue): string | undefined {
    if (mode === 'page' && !value.customPageId) return 'Página é obrigatória';
    if (mode === 'url' && !value.url?.trim()) return 'URL é obrigatória';
    return undefined;
}
